import clsx from 'clsx';
import dynamic from 'next/dynamic';
import DOMPurify from 'isomorphic-dompurify';
import { Heading, headingType, size, useWindowSize, Button } from '@marriott/mi-ui-library';
import { removeParentTagRTE } from '../utils/helpers';
import { IMerchandisingPortalModalContent } from '../organisms/MerchandisingPortalModal/MerchandisingPortalModal.types';

const MerchandisingPortalModalVariations = dynamic(() =>
  import('./MerchandisingPortalModalVariations').then(mod => mod.MerchandisingPortalModalVariations)
);

export const MerchandisingPortalModalContent = (props: IMerchandisingPortalModalContent) => {
  const {
    isTargetContentLoaded,
    introCopy,
    headerMedium,
    isVariationsAvailable,
    variationProps,
    openInaNewTab,
    mathType,
    callToActionText1,
    destinationUrl1,
  } = props;

  const sanitizedNode = DOMPurify?.sanitize(introCopy, { RETURN_DOM: true });
  const fragmentString = (sanitizedNode as unknown as HTMLElement)?.innerHTML;
  const { width = 0 } = useWindowSize();
  return (
    <div className={clsx('merchandising-portal-modal__content px-5 d-flex flex-column text-center')}>
      {isTargetContentLoaded && introCopy && (
        <div
          className={clsx(width < 576 ? 't-subtitle-alt-l' : 't-subtitle-alt-xl', 'mt-3 m-ellipsis-2lines')}
          dangerouslySetInnerHTML={{ __html: fragmentString }}
        />
      )}
      {isTargetContentLoaded && headerMedium && (
        <Heading
          customClass={clsx('my-3 m-ellipsis-2lines')}
          variation={headingType.title}
          fontSize={size.small}
          dangerouslySet={removeParentTagRTE(headerMedium) ?? ''}
        />
      )}
      <div
        className={clsx({
          'px-md-5': isVariationsAvailable,
          'd-flex flex-column': !(mathType?.toLowerCase() === 'currency' && !variationProps?.currencyType), // for rest all other vriations we need this class
        })}
      >
        {isVariationsAvailable && <MerchandisingPortalModalVariations {...variationProps} />}
        {isTargetContentLoaded && callToActionText1 && destinationUrl1 && (
          <Button
            className={clsx(
              'merchandising-portal-modal__button',
              `m-button-primary m-button-m mb-4 px-3 text-center align-self-center`
            )}
            href={destinationUrl1}
            target={openInaNewTab === true ? '_blank' : '_self'}
            isLink={true}
            buttonCopy={callToActionText1}
          />
        )}
      </div>
    </div>
  );
};
